
<template>
    <div class="center">
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Historial de movimientos</h4>
                <vs-row class="mt-4">
                    <vs-col class="ml-auto" sm="12" lg="4">
                         <vs-input v-model="texto" placeholder="Buscar">
                            <template #icon>
                                <i class="fas fa-search"></i>
                            </template>
                        </vs-input>
                    </vs-col>
                    <vs-col>
                        <vs-table>
                            <template #thead>
                            <vs-tr>
                                <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                Nombre
                                </vs-th>
                                <vs-th sort @click="users = $vs.sortData($event ,users, 'accion')">
                                Acción
                                </vs-th>
                                <vs-th sort @click="users = $vs.sortData($event ,users, 'sesion')">
                                Última sesión
                                </vs-th>
                            </vs-tr>
                            </template>
                            <template #tbody>
                            <vs-tr
                                :key="i"
                                v-for="(tr, i) in $vs.getSearch(users, search)"
                                :data="tr"
                            >
                                <vs-td>
                                    <p class="mb-0"><strong>{{ tr.nombre }}</strong></p>
                                    <p class="mb-0">{{ tr.correo }}</p>
                                </vs-td>
                                <vs-td>
                                {{ tr.accion }}
                                </vs-td>
                                <vs-td>
                                {{ tr.fecha }}
                                </vs-td>
                            </vs-tr>
                            </template>
                            <template #footer>
                                <vs-pagination  v-model="page" :length="pages" />           
                            </template>
                            <template #notFound>
                                No hay registros
                            </template>
                        </vs-table>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import catalogos from '../../../api/requests/catalogos.js'
import cobranza from '../../../api/requests/cobranza-persona'
    export default {
        data:() => ({
            search: '',
            users: [],
            id_alumno: '',
            institucion: '',
            cicloEscolar: '',
            programa: '',
            nivel: '',
            page: 1, 
            max: 20,
            pages: 0,
            texto: ''
        }),
        created(){
            const url = window.location.pathname.split('/')
            this.id_alumno = url[2]
            this.getInstitucioneDefault()
        },
        methods:{
            async getHistorial(){
                if (this.id_alumno){
                    try {
                        const persona_id = atob(this.id_alumno)
                        const params = {
                            "page": this.page || 1,
                            "size": this.max || 20,
	                        "institucion": this.institucion,
                            "programa": this.programa,
                            "ciclo_escolar": this.cicloEscolar,
	                        "texto": this.texto,
                            "id": persona_id,
                        }
                        const { data: responseHistorial = null } = await cobranza.getHistorial(params)
                        const { data: dataHistorial = [], per_page = 20, total = 0 } = responseHistorial || {}
                        this.pages = Math.ceil(total/per_page) || 0
                        this.users = dataHistorial
                        console.log(this.users)
                        this.alumno = response.data
                        this.nombre = response.data.nombre
                        this.idPersona = btoa(this.personaId)
                    } catch (error) {
                        
                    }
                }
            },
            async getInstitucioneDefault () {
                if (this.id_alumno){
                    const persona_id = atob(this.id_alumno)
                    let params = {
                        "persona": persona_id
                    }
                    const { data: response } = await catalogos.getInstitutosDefault(params) || {}
                    const { opciones: info, default: val } = response || {}
                    this.listInstituciones = info instanceof Object ?  Object.values(info) : []
                    this.institucion = val
                    this.institucionId = (new Date()).getTime()
                    this.idInstitucion = btoa(this.institucion)
                }
            },
            async getCicloDefault() {
                if (this.institucion){
                    let params = {
                        "nivel_academico": this.nivel,
                        "institucion_id": this.institucion,
                    }
                    const { data: response } = await catalogos.getCicloDefault(params) || {}
                    const { opciones: info, default: val = null } = response || {}
                    this.listCiclos = info instanceof Object ?  Object.values(info) : []
                    this.cicloEscolar = val
                    this.cicloId = (new Date()).getTime()
                }
            },
            async getProgramas () {
                if (this.institucion && this.cicloEscolar){
                const persona_id = atob(this.id_alumno)
                let params = {
                    institucion: this.institucion,
                    id: persona_id,
                    ciclo_escolar: this.cicloEscolar,
                }

                if (this.nivel){
                    params.nivel_academico = this.nivel
                }
                
                const { data: response } = await cobranza.getPrograma(params) || {}
                const { opciones: programas, default:val } = response || {}
                    if (programas){
                        this.listPrograma = Object.values(programas)
                        this.programa = val
                        this.programaDefault = val
                        this.programaId = (new Date()).getTime()
                    }
                }
            },
        },
        watch:{
            institucion(){
                this.getCicloDefault()
            },
            cicloEscolar(){
                this.getProgramas()
            },
            programa(){
                this.getHistorial()
            },
            page () {
                this.getHistorial()
            },
            texto(){
                this.getHistorial()
            }
        }
    }
    </script>

    
<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }

</style>

        